export function decodeBase64(base64: string) {
    // base64字符串解码
    const buffer = Buffer.from(base64, 'base64');
    return buffer.toString();
}

export function decodeJwtPayload(jwt: string) {
    const parts = jwt.split('.');
    return JSON.parse(decodeBase64(parts[1]));
}
